<template>
  <v-card :style="`${mobile ? 'height: 250px !important' : 'height: 400px'}`">
    <v-layout mx-3 pt-4 row wrap justify-space-between>
      <v-flex sm8>
        <span class="title-queue"
          >Você está na fila virtual para adquirir ingressos</span
        >
      </v-flex>
      <v-flex mt-4 sm12>
        <span class="subtitle-queue"
          >Mantenha esta página aberta. Não é necessário recarregar.</span
        >
      </v-flex>
    </v-layout>
    <v-layout mx-3 my-4>
      <div class="box-queue">
        <span class="text-queue"
          >Sua posição na fila:
          <span class="number-queue pl-1">{{
            position ? position.toFixed(0) : '-'
          }}</span></span
        >
        <v-spacer></v-spacer>
        <v-progress-circular
          class="mr-2"
          indeterminate
          color="#1976d2"
          style="color: #1976d2 !important"
        ></v-progress-circular>
      </div>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      interval: null,
      status: '',
      positionModel: null,
      timeInterval: 30000,
    };
  },
  watch: {
    status(v) {
      if (v === 'L') {
        this.$store.dispatch('setSectorsList');
        this.$store.commit('SET_SHOW_QUEUE', false);
        clearInterval(this.interval);
        if (this.$route.name === 'commissioner') {
          this.$store.dispatch('getOrderDetails', this.$route.params.hash);
        }
        this.$store.commit('SET_MESSAGE_QUEUE', true);
      }
    },
  },
  computed: {
    ...mapGetters(['eventDetails']),

    eventId() {
      return this.$store.getters.eventID;
    },
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true;
        case 'sm':
          return true;
      }
    },
    position() {
      if (!this.positionModel) return this.$store.getters.positionQueue;
      else return this.positionModel;
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    returnTimeInterval(value) {
      if (value && value <= 250) return 15000;
      else if (value && value > 250 && value <= 500) return 30000;
      else if (value && value > 500 && value <= 1500) return 45000;
      else if (value && value > 1500 && value <= 5000) return 60000;
      else if (value && value > 5000) return 90000;
      return 30000;
    },
    async dropPosition(newPosition) {
      this.timeInterval = this.returnTimeInterval(newPosition);
      if (!this.positionModel) this.positionModel = newPosition;
      else {
        if (this.positionModel === newPosition) return;
        let drop,
          timeDrop = 0;
        drop = (this.positionModel - newPosition) / 4;
        timeDrop = this.timeInterval / 4;
        setTimeout(() => {
          this.positionModel = this.positionModel - drop;
        }, timeDrop);
        setTimeout(() => {
          this.positionModel = this.positionModel - drop;
        }, timeDrop * 2);
        setTimeout(() => {
          this.positionModel = this.positionModel - drop;
        }, timeDrop * 3);
        setTimeout(() => {
          this.positionModel = this.positionModel - drop;
        }, timeDrop * 4);
      }
    },

    getQueuePosition() {
      let uuid = JSON.parse(localStorage.getItem(`queue_uuid_${this.eventId}`));
      this.$store
        .dispatch('getQueue', {
          event: this.eventId,
          uuid: uuid ? uuid.uuid : '',
        })
        .then(async resp => {
          if (resp.data && resp.data.success) {
            let obj = {
              uuid: resp.data.uuid,
              position: resp.data.position,
            };
            this.$store.commit('SET_QUEUE_TEXT', resp.data.text);
            this.status = resp.data.status;
            this.$store.commit('SET_QUEUE_TEXT', resp.data.text);
            await this.dropPosition(resp.data.position);
            localStorage.setItem(
              `queue_uuid_${this.eventId}`,
              JSON.stringify(obj)
            );
            clearInterval(this.interval);
            if (resp.data.status !== 'L') {
              this.setIntervalQueue();
            }
          }
        });
    },

    setIntervalQueue() {
      this.interval = setInterval(() => {
        this.getQueuePosition();
      }, this.timeInterval);
    },
  },
  mounted() {
    if (this.eventDetails && this.eventDetails.site_visibilidade === 'Y')
      this.getQueuePosition();
    this.setIntervalQueue();
  },
};
</script>

<style scoped>
.container-queue {
  height: 400px;
}
.title-queue {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  letter-spacing: -0.25px;
  text-align: left;
}
.subtitle-queue {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.25px;
  text-align: left;
}
.box-queue {
  height: 64px;
  width: 426px;
  padding: 10px 15px;
  background: #1976d23d;
  border-radius: 12px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.text-queue {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.25px;
  text-align: right;
  font-weight: bold;
  color: #192b46;
}
.number-queue {
  font-size: 24px;
  line-height: 16px;
  letter-spacing: -0.25px;
  text-align: right;
  font-weight: bold;
  color: #192b46;
}
</style>
